import { FDV_URL, IDUSUARIO, customAxios, USERNAME } from '../constants';
import {  SAVE_AUTORIZACIONES_EXCEPCIONALES, FETCH_SEGUIMIENTO_AUTORIZACIONES } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function saveAutorizacionesExcepcionales(codigoSolicitud, codigoEstado, indInactivo) {
  const config = {
    headers: {

    },
    params: {
      idUsuario: IDUSUARIO,
      codigoUsuario : USERNAME
    },
  };

  const data =  {
    codigoSolicitud: codigoSolicitud,
    codigoEstado: codigoEstado,
    indInactivo: indInactivo,
  };

    const request = customAxios.put(`${FDV_URL}/autorizacion-excepcional/${codigoSolicitud}/estado/seguimiento`, data, config)
    .then(({ data }) => evalAction(data, 'listar'))
    .catch(error => serverError(error, 'listar'))

    return {
      type: SAVE_AUTORIZACIONES_EXCEPCIONALES,
      payload: request,
    };

  }

  export function fetchSeguimientoAutorizaciones() {
    const config = {
      headers: {
        idUsuario: IDUSUARIO,
        codUsuario : USERNAME
      }

    };

      const request = customAxios.get(`${FDV_URL}/autorizacion-excepcional/estado/seguimiento`, config)
      .then(({ data }) => evalAction(data, 'listar'))
      .catch(error => serverError(error, 'listar'))

      return {
        type: FETCH_SEGUIMIENTO_AUTORIZACIONES,
        payload: request,
      };

    }



// WEBPACK FOOTER //
// ./src/actions/SeguimientoAutorizaciones.js